import React, { createContext, useContext, useEffect, useState } from 'react'
const { vsgPublicKey, vsgEnvironment, vsgRecaptchaKey } = require('../config.json')

const VsgSdkContext = createContext({})

export const useVsgSdk = () => useContext(VsgSdkContext)

export const VsgSdkContextProvider = ({ children }) => {
  const [vsgSdkInstance, setVsgSdkInstance] = useState(undefined)

  useEffect(() => {
    const loadSdk = async () => {
      const { init } = await import('@veloe/vsg-sdk-wc-lib')
      const instance = init({
        environment: vsgEnvironment,
        publicKey: vsgPublicKey,
        recaptchaSiteKey: vsgRecaptchaKey,
        themeConfig: {
          brand: 'veloe',
          mode: 'light',
          theme: 'default_theme'
        }
      })
      setVsgSdkInstance(instance)
    }

    loadSdk()
  }, [])

  if (!vsgSdkInstance) {
    return null
  }

  return <VsgSdkContext.Provider value={vsgSdkInstance}>{children}</VsgSdkContext.Provider>
}

export default VsgSdkContextProvider
